import gql from 'graphql-tag';
import { CurrencyFragment } from '../fragments/currency.fragment';
import { PageFragment } from '../fragments/page.fragment';

export const GET_CURRENCY = gql`
    query (
        $filter: CurrencyFilter
    ) {
        currencies (
            paging: {first: 9999}
            filter: $filter
            sorting: { field: name, direction: ASC }
        ) {
            pageInfo {
                ...Page
            }
            edges {
                node {
                    ...CurrencyInfo
                }
            }
        }
    }
    ${CurrencyFragment}
    ${PageFragment}
`;